import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs, FreeMode } from "swiper";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import MediaViewer from "../../../../../common/mediaViewer";

const Images = ({ media, clickImage }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  return (
    <div className="images">
      {media && media?.length > 0 ? (
        <>
          <Swiper
            slidesPerView={1}
            thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
            modules={[FreeMode, Navigation, Thumbs]}
            loop={true}
            navigation={true}
            speed={500}
            className="mainSwiper">
            {media.map((item, index) => (
              <SwiperSlide key={`main-${index}`}>
                <div className="image" onClick={() => clickImage(item)}>
                  <img
                    src={item ? imgHandler(item) : "/img/function_11_bg.png"}
                    onError={onErrorImg}
                    alt={`main-${index}`}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <Swiper
            onSwiper={setThumbsSwiper}
            slidesPerView={4}
            freeMode={true}
            watchSlidesProgress={true}
            modules={[FreeMode, Thumbs]}
            className="thumbsSwiper"
            spaceBetween={10}>
            {media.map((item, index) => (
              <SwiperSlide key={`thumb-${index}`}>
                <img
                  src={item ? imgHandler(item) : "/img/function_11_bg.png"}
                  onError={onErrorImg}
                  alt={`thumbnail-${index}`}
                  className="thumb-img"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Images;
